import { env } from '@/shared/config/env';

/** HTTP header used to propagate the active tenant to backend services. */
export const TENANT_HEADER = 'X-Tenant-Id';

/** Static API client configuration derived from the environment. */
export const apiConfig = {
  /** Base URL of the API gateway. */
  baseURL: env.apiBaseUrl,
  /** Request timeout in milliseconds. */
  timeout: 30_000,
  /** Header name used to send the active tenant id. */
  tenantHeader: TENANT_HEADER,
} as const;
